angular.module('rjmNg.directives').directive "dynamicFontStyle", [
  () ->
    restrict: "A"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope: true
    controller: [
      "$element"
      "$rootScope"
      (
        $element
        $rootScope
      ) ->

        view = @

        view.updateFontStyle = () ->
          elementHeight = $element.height()
          baseHeight = if elementHeight < 21 then 21 else elementHeight

          if baseHeight < 24
            fontWeight = 600
          else if 24 <= baseHeight and baseHeight < 49
            fontWeight = 400
          else
            fontWeight = 300

          fontSize = if baseHeight < 49 then baseHeight * .8 else baseHeight * .7
          lineHeight = if baseHeight < 49 then baseHeight * .9 else baseHeight * .8

          $element.find('.dynamic-font-style-target')
            .css('font-size', "#{fontSize}px")
            .css('line-height', "#{lineHeight}px")
            .css('font-weight', "#{fontWeight}")

        view.$postLink = () ->
          view.updateFontStyle()

        _gridsterResizedlListener = $rootScope.$on('gridster-resized', view.updateFontStyle)

        view.$onDestroy = () ->
          _gridsterResizedlListener()
          return

        return view
    ]
]
